module.exports = __webpack_public_path__ + "img/suolue.3f7ada4b.png";